import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { OtherEquipmentConnectionState } from './types';

export const getters: GetterTree<OtherEquipmentConnectionState, RootState> = {}
